module.exports = __webpack_public_path__ + "img/help.fa92fdbf.png";